import React from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import { Formik } from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import '../../css/contactus.css'
import FormImg from '../../Images/Default/feedback-img.png'
import emailjs from "@emailjs/browser"
import axios from 'axios'

const ContactUs = () => {

    const phoneRegExp = /^\d{10}$/; //Regular expression to match 10-digit phone number

    const validateFeedbackSchema = Yup.object().shape({
        name: Yup.string()
            .required("Full Name is Required !!")
            .min(10, "Must have at least 10 Characters !!")
            .max(30, "Must be less than 30 Characters !!"),
        contactno: Yup.string()
            .matches(phoneRegExp, "Invalid Number !!")
            .required("Number Required !!"),
        message: Yup.string()
            .required("Message is Required !!")
            .min(5, "Must have at least 5 Characters !!")
            .max(100, "Must be less than 100 Characters !!"),
        email: Yup.string().email()
            .required("Email is Required !!"),
        subject: Yup.string()
            .required("Subject is Required !!")
            .min(5, "Must have at least 5 Characters !!")
            .max(50, "Must be less than 50 Characters !!"),
    })

    return (
        <>
            <div className='main'>
                {/* <div className='left-fixed'></div> */}
                <div className='contact-us-body'>
                    <div className='contact-us-header'>
                        <div className='welcome-title-center'>
                            <h2><span>सुझाव तथा गुनासो</span></h2>
                        </div>
                    </div>
                    <div className="contact-form">
                        <h3>हजुरहरुसंग भएको सुझाव तथा गुनासोहरु हामीलाई पठाउनुहोस् ।</h3>
                        <Formik
                            initialValues={{ name: "", contactno: "", email: "", subject: "", message: "" }}
                            validationSchema={validateFeedbackSchema}
                            onSubmit={
                                (values, { setSubmitting, resetForm }) => {
                                    Swal.fire({
                                        title: 'Are You Sure?',
                                        showDenyButton: true,
                                        showCancelButton: true,
                                        confirmButtonText: 'Send',
                                        denyButtonText: `Don't Send`,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            // Swal.fire('Successfully Send!', 'Thank You For Your Feedback.', 'success')
                                            setSubmitting(true);

                                            // console.log("serviceid:", `${process.env.REACT_APP_SID}`)
                                            // console.log("templateid:", `${process.env.REACT_APP_TEMPID}`)
                                            // console.log("publickey:", `${process.env.REACT_APP_PKEY}`)
                                            // console.log('values:', values)

                                            // emailjs.init(REACT_APP_PKEY)
                                            emailjs.send(`${process.env.REACT_APP_SID}`, `${process.env.REACT_APP_TEMPID}`, values, `${process.env.REACT_APP_PKEY}`)
                                                .then((response) => {
                                                    console.log("Success", response.status, response.text)
                                                    if (response.status === 200) {
                                                        console.log("response text:", response.text)
                                                        resetForm()
                                                        setSubmitting(false)
                                                        Swal.fire('DONE', 'THANK YOU FOR YOUR FEEDBACK', 'success')
                                                    }
                                                    else {
                                                        Swal.fire('Error', 'Failed to send feedback. Please try again.', 'error')
                                                    }
                                                })
                                            // .catch((error) => {
                                            //     console.log("Error:", error)
                                            //     Swal.fire('Error', 'Failed to send feedback. Please try again.', 'error')
                                            // })
                                            try {
                                                axios.post(`${process.env.REACT_APP_API_URL}/feedback`, values)
                                                    .then((response) => {
                                                        if (response.data.status === "Success") {
                                                            console.log("Feedback added successfully:", response.data);
                                                        }
                                                        else {
                                                            console.error("Failed to add feedback:", response.data);
                                                        }
                                                    })
                                                    .catch((error) => {
                                                        console.error("Error sending feedback:", error);
                                                    })
                                            }
                                            catch (error) {
                                                console.error("Error adding feedback:", error);
                                            }
                                        }
                                        else if (result.isDenied) {
                                            Swal.fire('Sending Failed!', '', 'error')
                                        }
                                    }).then(setSubmitting(false))
                                }
                            }
                        >
                            {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => (

                                <Form onSubmit={handleSubmit} className='form'>
                                    <Form.Group as={Row} className='mb-3' controlId='name'>
                                        <Col sm='10'>
                                            <Form.Control type='text' name='name' placeholder='Enter Full Name *' onChange={handleChange} value={values.name} style={{ borderColor: touched.name && errors.name ? "red" : null }} />
                                            {touched.name && errors.name ? (
                                                <Col className="error-message">{errors.name}</Col>
                                            ) : null}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-3' controlId='email'>
                                        <Col sm='10'>
                                            <Form.Control type='text' name='email' placeholder='Enter Your Email *' onChange={handleChange} value={values.email} style={{ borderColor: touched.email && errors.email ? "red" : null }} />
                                            {touched.email && errors.email ? (
                                                <Col className="error-message">{errors.email}</Col>
                                            ) : null}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-3' controlId='contactno'>
                                        <Col sm='10'>
                                            <Form.Control type='text' name='contactno' placeholder='Enter Mobile No *' onChange={handleChange} value={values.contactno} style={{ borderColor: touched.contactno && errors.contactno ? "red" : null }} />
                                            {touched.contactno && errors.contactno ? (
                                                <Col className="error-message">{errors.contactno}</Col>
                                            ) : null}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-3' controlId='subject'>
                                        <Col sm='10'>
                                            <Form.Control type='text' name='subject' placeholder='Enter Subject *' onChange={handleChange} value={values.subject} style={{ borderColor: touched.subject && errors.subject ? "red" : null }} />
                                            {touched.subject && errors.subject ? (
                                                <Col className="error-message">{errors.subject}</Col>
                                            ) : null}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className='mb-3' controlId='message'>
                                        <Col sm='10'>
                                            <Form.Control as='textarea' name='message' rows={7} placeholder='Enter Your Message . . . *' onChange={handleChange} value={values.message} style={{ borderColor: touched.message && errors.message ? "red" : null }} />
                                            {touched.message && errors.message ? (
                                                <Col className="error-message">{errors.message}</Col>
                                            ) : null}
                                        </Col>
                                    </Form.Group>
                                    <div className="feedback-button">
                                        <button type='submit' disabled={isSubmitting}>Send</button>
                                    </div>
                                </Form>
                            )}

                        </Formik>
                    </div>
                    <div className='contactimg'>
                        <img src={FormImg} alt='Feedback' />
                    </div>
                </div>
                {/* <div className='right-fixed'></div> */}
            </div>
        </>
    )
}

export default ContactUs